import React, { ReactElement } from 'react';
import classnames from 'classnames';
import styles from './filters.module.scss';

interface FiltersRowProps {
  renderSearchBox: () => ReactElement;
}

const FiltersRow = ({ renderSearchBox }: FiltersRowProps) => {
  return (
    <div className="d-flex align-items-center">
      <p className={classnames('mb-0', styles.filterByText)}>Filter by </p>
      {renderSearchBox()}
    </div>
  );
};

export default FiltersRow;
